export const workTypesConstants = {
  Maintenance: 'Maintenance',
  Malfunctions: 'Malfunctions',
  RepairsBodywork: 'Repairs - Bodywork',
  RepairsGlass: 'Repairs - Glass',
  TireSwap: 'Tire Swap',
};

export const rolesConstants = {
  Technician: 'Technician',
  CallCenterAgent: 'Call Center Agent',
  Accounting: 'Accounting',
  Legal: 'Legal',
  Sales: 'Sales',
  ClaimsInsuranceAgent: 'Claims/Insurance Agent',
  Owner: 'Owner',
};

export const servicePointGridColumns = [
  { value: true, label: 'Status', key: 'status' },
  { value: true, label: 'Internal ID', key: 'internalId' },
  { value: true, label: 'Name', key: 'name' },
  { value: true, label: 'Region', key: 'region' },
  { value: true, label: 'Working Days/Hours', key: 'workdays' },
  { value: true, label: 'Primary Contact Name', key: 'primaryContactName' },
  { value: true, label: 'Primary Contact Number', key: 'primaryContactNumber' },
];
